import objectPath from 'object-path'

const getRuleActiveButtonTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const getRuleActiveButtonStatus = (status = {}) => {
  let { isDynamic, dynamicName, dynamicKey, dynamicIndex } = status

  return {
    isDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
  }
}

export const onRuleActiveButton = (
  designContext = {},
  action = {},
  status = {},
  target = '',
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let targetKey = getRuleActiveButtonTarget(action, target)
  if (!targetKey) return undefined

  objectPath.set(isUiChanged, targetKey, {
    isActiveButton: true,
    ...getRuleActiveButtonStatus(status),
  })
  if (setIsUiChanged) setIsUiChanged(isUiChanged)

  return {
    key: targetKey,
    isActiveButton: true,
  }
}

export const onRuleClearActiveButton = (designContext = {}) => {
  let { setActiveButton } = designContext
  if (setActiveButton) setActiveButton(null)

  return {
    activeButton: null,
  }
}
